import { CssVarsProvider } from '@mui/material/styles';
import type * as React from 'react';

import { theme } from '../theme';

interface AppThemeProps {
  children: React.ReactNode;
}

export const ThemeRegistry = ({ children }: AppThemeProps) => {
  return (
    <CssVarsProvider theme={theme} defaultMode='light' modeStorageKey='mex-color-mode' attribute='data-theme'>
      {children}
    </CssVarsProvider>
  );
};
